'use strict';

module.exports = require('react/lib/ReactDOMServer');



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-dom/server.js
 ** module id = 848
 ** module chunks = 0
 **/